import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bottom-navigation',
  templateUrl: './bottom-navigation.component.html',
  styleUrls: ['./bottom-navigation.component.scss'],
  standalone: false,
})
export class BottomNavigationComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
